export const ActivityTargetMap = {
  // 双十一活动相关
  DoubleEleven_auto_Show: "DoubleEleven_auto_Show", // 双十一活动自动展示
  DoubleEleven_Click_Tip_New: "DoubleEleven_Click_Tip_New", // 双十一活动点击提示（新版）
  DoubleEleven_Click_Tip_Old: "DoubleEleven_Click_Tip_Old", // 双十一活动点击提示（旧版）
  DoubleEleven_Click_Header_GetDiscount:
    "DoubleEleven_Click_Header_GetDiscount", // 双十一活动点击卡片Header获取优惠
  DoubleEleven_Click_LeadContact_CompanyPage_GetDiscount:
    "DoubleEleven_Click_LeadContact_CompanyPage_GetDiscount", // 双十一活动点击领英生态外company页面获取优惠
  DoubleEleven_Click_UpgradeDialog_GetDiscount:
    "DoubleEleven_Click_UpgradeDialog_GetDiscount", // 双十一活动点击卡片UpgradeDialog获取优惠
  DoubleEleven_LeadContact_Auto_Show: "DoubleEleven_LeadContact_Auto_Show", // 双十一活动领英生态外侧边栏自动展示
  DoubleEleven_Card_Auto_Show: "DoubleEleven_Card_Auto_Show", // 双十一活动领英卡片自动展示
  DoubleEleven_Side_Auto_Show: "DoubleEleven_Side_Auto_Show", // 双十一活动侧边栏自动展示

  // 万圣节活动相关
  Halloween_Auto_Show: "Halloween_Auto_Show", // 万圣节活动自动展示
  Halloween_Click_Tip_New: "Halloween_Click_Tip_New", // 万圣节活动点击提示（新版）
  Halloween_Click_Tip_Old: "Halloween_Click_Tip_Old", // 万圣节活动点击提示（旧版）
  // black friday
  BlackFriday_Auto_Show: "BlackFriday_Auto_Show", // 黑五活动自动展示
  Black_Friday_Web_Popup_Button_Click: "Black_Friday_Web_Popup_Button_Click", // 黑五活动点击弹窗按钮
  BlackFriday_Card_Auto_Show: "BlackFriday_Card_Auto_Show", // 黑五活动领英卡片自动展示
  Black_Friday_Card_Popup_Button_Click: "Black_Friday_Card_Popup_Button_Click", // 黑五活动领英卡片点击弹窗按钮
  BlackFriday_LeadContact_Auto_Show: "BlackFriday_LeadContact_Auto_Show", // 黑五活动领英生态外侧边栏自动展示
  Black_Friday_LeadContact_Popup_Button_Click: "Black_Friday_LeadContact_Popup_Button_Click", // 黑五活动领英生态外点击弹窗按钮
  BlackFriday_Side_Auto_Show: "BlackFriday_Side_Auto_Show", // 黑五活动侧边栏自动展示
  Black_Friday_Side_Popup_Button_Click: "Black_Friday_Side_Popup_Button_Click", // 黑五活动侧边栏点击弹窗按钮
  Black_Friday_LeadContact_Tip_Button_Click:
    "Black_Friday_LeadContact_Tip_Button_Click", // 黑五活动点击领英生态外常驻提示按钮点击
  Black_Friday_Card_Tip_Button_Click:
    "Black_Friday_Card_Tip_Button_Click", // 黑五活动点击卡片常驻提示按钮点击
  // 双十二活动相关
  DoubleTwelve_Auto_Show: "DoubleTwelve_Auto_Show", // 双十二活动自动展示
  Double_Twelve_Web_Popup_Button_Click: "Double_Twelve_Web_Popup_Button_Click", // 双十二活动点击弹窗按钮
  DoubleTwelve_Card_Auto_Show: "DoubleTwelve_Card_Auto_Show", // 双十二活动领英卡片自动展示
  Double_Twelve_Card_Popup_Button_Click: "Double_Twelve_Card_Popup_Button_Click", // 双十二活动领英卡片点击弹窗按钮
  DoubleTwelve_LeadContact_Auto_Show: "DoubleTwelve_LeadContact_Auto_Show", // 双十二活动领英生态外侧边栏自动展示
  Double_Twelve_LeadContact_Popup_Button_Click: "Double_Twelve_LeadContact_Popup_Button_Click", // 双十二活动领英生态外点击弹窗按钮
  DoubleTwelve_Side_Auto_Show: "DoubleTwelve_Side_Auto_Show", // 双十二活动侧边栏自动展示
  Double_Twelve_Side_Popup_Button_Click: "Double_Twelve_Side_Popup_Button_Click", // 双十二活动侧边栏点击弹窗按钮
  Double_Twelve_LeadContact_Tip_Button_Click:
    "Double_Twelve_LeadContact_Tip_Button_Click", // 双十二活动点击领英生态外常驻提示按钮点击
  Double_Twelve_Card_Tip_Button_Click:
    "Double_Twelve_Card_Tip_Button_Click", // 双十二活动点击卡片常驻提示按钮点击
  Double_Twelve_Old_Billing_Page_Tip_Click: "Double_Twelve_Old_Billing_Page_Tip_Click", // 双十二活动旧Billing页常驻提示按钮点击
  Double_Twelve_New_Billing_Page_Tip_Click: "Double_Twelve_New_Billing_Page_Tip_Click", // 双十二活动新Billing页常驻提示按钮点击
  // 圣诞活动相关
  Christmas_Auto_Show: "Christmas_Auto_Show", // 圣诞活动自动展示
  Christmas_Web_Popup_Button_Click: "Christmas_Web_Popup_Button_Click", // 圣诞活动点击弹窗按钮
  Christmas_Card_Auto_Show: "Christmas_Card_Auto_Show", // 圣诞活动领英卡片自动展示
  Christmas_Card_Popup_Button_Click: "Christmas_Card_Popup_Button_Click", // 圣诞活动领英卡片点击弹窗按钮
  Christmas_LeadContact_Auto_Show: "Christmas_LeadContact_Auto_Show", // 圣诞活动领英生态外侧边栏自动展示
  Christmas_LeadContact_Popup_Button_Click: "Christmas_LeadContact_Popup_Button_Click", // 圣诞活动领英生态外点击弹窗按钮
  Christmas_Side_Auto_Show: "Christmas_Side_Auto_Show", // 圣诞活动侧边栏自动展示
  Christmas_Side_Popup_Button_Click: "Christmas_Side_Popup_Button_Click", // 圣诞活动侧边栏点击弹窗按钮
  Christmas_LeadContact_Tip_Button_Click:
    "Christmas_LeadContact_Tip_Button_Click", // 圣诞活动点击领英生态外常驻提示按钮点击
  Christmas_Card_Tip_Button_Click:
    "Christmas_Card_Tip_Button_Click", // 圣诞活动点击卡片常驻提示按钮点击
  Christmas_Old_Billing_Page_Tip_Click: "Christmas_Old_Billing_Page_Tip_Click", // 圣诞活动旧Billing页常驻提示按钮点击
  // 中国年末活动相关
  New_Year_Auto_Show: "New_Year_Auto_Show", // 中国年末活动自动展示
  New_Year_Web_Popup_Button_Click: "New_Year_Web_Popup_Button_Click", // 中国年末活动点击弹窗按钮
  New_Year_Card_Auto_Show: "New_Year_Card_Auto_Show", // 中国年末活动领英卡片自动展示
  New_Year_Card_Popup_Button_Click: "New_Year_Card_Popup_Button_Click", // 中国年末活动领英卡片点击弹窗按钮
  New_Year_LeadContact_Auto_Show: "New_Year_LeadContact_Auto_Show", // 中国年末活动领英生态外侧边栏自动展示
  New_Year_LeadContact_Popup_Button_Click: "New_Year_LeadContact_Popup_Button_Click", // 中国年末活动领英生态外点击弹窗按钮
  New_Year_Side_Auto_Show: "New_Year_Side_Auto_Show", // 中国年末活动侧边栏自动展示
  New_Year_Side_Popup_Button_Click: "New_Year_Side_Popup_Button_Click", // 中国年末活动侧边栏点击弹窗按钮
  New_Year_LeadContact_Tip_Button_Click:
    "New_Year_LeadContact_Tip_Button_Click", // 中国年末活动点击领英生态外常驻提示按钮点击
  New_Year_Card_Tip_Button_Click:
    "New_Year_Card_Tip_Button_Click", // 中国年末活动点击卡片常驻提示按钮点击
  New_Year_Old_Billing_Page_Tip_Click: "New_Year_Old_Billing_Page_Tip_Click", // 中国年末活动旧Billing页常驻提示按钮点击
};
